import './Pagination.css';

// Pagination is the reusable page navigation bar for library browse
// pages: prev/next, a compact page indicator, and the per-page selector.
// It owns no state - the hosting page passes page/totalPages plus the
// setters from usePagedUrl, so this stays a dumb, reusable component.

export interface PaginationProps {
    page: number;
    totalPages: number;
    perPage: number;
    onPageChange: (page: number) => void;
    onPerPageChange: (perPage: number) => void;
    perPageChoices?: readonly number[];
}

export function Pagination({
    page,
    totalPages,
    perPage,
    onPageChange,
    onPerPageChange,
    perPageChoices = [25, 50, 100, 250],
}: PaginationProps): React.JSX.Element {
    const canPrev = page > 1;
    const canNext = page < totalPages;

    return (
        <nav className="paginationBar" aria-label="Pagination">
            <button
                type="button"
                className="paginationButton"
                disabled={!canPrev}
                onClick={() => onPageChange(page - 1)}
            >
                &lsaquo; Prev
            </button>
            <span className="paginationStatus">
                Page {page} of {totalPages}
            </span>
            <button
                type="button"
                className="paginationButton"
                disabled={!canNext}
                onClick={() => onPageChange(page + 1)}
            >
                Next &rsaquo;
            </button>
            <label className="paginationPerPage">
                Per page
                <select
                    value={perPage}
                    onChange={(e) => onPerPageChange(Number(e.target.value))}
                >
                    {perPageChoices.map((choice) => (
                        <option key={choice} value={choice}>
                            {choice}
                        </option>
                    ))}
                </select>
            </label>
        </nav>
    );
}
